document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  if (!header) return;

  // Alle details-Elemente im Header AUSSER im Drawer überwachen
  const allDetails = header.querySelectorAll('details:not([id*="Details-menu-drawer"])');

  allDetails.forEach(details => {
    // Beim Öffnen: alle anderen schließen
    details.addEventListener('toggle', () => {
      if (details.open) {
        allDetails.forEach(other => {
          if (other !== details && other.open) {
            other.removeAttribute('open');
          }
        });
      }
    });
  });

  // Klick außerhalb schließt alles (aber nicht im Drawer)
  document.addEventListener('click', (e) => {
    if (!header.contains(e.target)) {
      allDetails.forEach(details => details.removeAttribute('open'));
    }
  });

  // Escape-Taste schließt alles (aber nicht im Drawer)
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      allDetails.forEach(details => details.removeAttribute('open'));
    }
  });
});